export default __webpack_public_path__ + "static/our-knowledge-base-7b42d5da2bc4789602829d09d9c7affd.svg";